import { render, staticRenderFns } from "./VersionsTab.vue?vue&type=template&id=1c2740d8"
import script from "./VersionsTab.vue?vue&type=script&lang=ts"
export * from "./VersionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports